import React, { useState } from 'react';
import { Save, Mail, Phone, MapPin, User, Store, CreditCard, Sparkles } from 'lucide-react';

const Settings = () => {
  const [settings, setSettings] = useState({
    general: {
      shopName: 'Manthuli Organic Shop',
      ownerName: 'Rajesh Kumar',
      email: 'info@manthuli.com',
      phone: '+91-9876543210',
      address: '123 Green Street, Organic Market, Mumbai - 400001',
      gst: 'GST123456789',
      currency: 'INR',
      timezone: 'Asia/Kolkata'
    }
  });

  const handleSettingChange = (category, key, value) => {
    setSettings(prev => ({
      ...prev,
      [category]: {
        ...prev[category],
        [key]: value
      }
    }));
  };

  const saveSettings = () => {
    alert('Settings saved successfully!');
  };

  return (
    <div className="ui-page animate-fade-in">
      {/* HEADER SECTION */}
      <div className="mb-8 flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <h1 className="text-3xl font-extrabold text-slate-800 tracking-tight">System Settings</h1>
          <p className="text-slate-500 mt-1 font-medium text-sm">Configure store attributes, contacts, taxation rules, and display currencies.</p>
        </div>
        
        <button 
          onClick={saveSettings}
          className="ui-btn-primary flex items-center gap-2 self-start md:self-auto"
        >
          <Save size={16} />
          Save Settings
        </button>
      </div>

      {/* SETTINGS CARD */}
      <div className="ui-card ui-card-pad max-w-4xl bg-white border border-slate-100 shadow-sm">
        <div className="space-y-6">
          <div className="flex items-center gap-3 pb-4 border-b border-slate-100">
            <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-emerald-600 to-green-700 flex items-center justify-center text-white shadow-lg shadow-emerald-600/20">
              <Sparkles size={16} />
            </div>
            <div>
              <h3 className="text-base font-extrabold text-slate-800">General Shop Profile</h3>
              <p className="text-slate-400 text-[11px] font-medium">Standard settings for printing invoices and customer visibility</p>
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* SHOP NAME */}
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Shop Name</label>
              <div className="relative">
                <Store className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
                <input
                  type="text"
                  value={settings.general.shopName}
                  onChange={(e) => handleSettingChange('general', 'shopName', e.target.value)}
                  className="ui-input w-full !pl-10 text-xs"
                />
              </div>
            </div>
            
            {/* OWNER NAME */}
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Owner / Manager Name</label>
              <div className="relative">
                <User className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
                <input
                  type="text"
                  value={settings.general.ownerName}
                  onChange={(e) => handleSettingChange('general', 'ownerName', e.target.value)}
                  className="ui-input w-full !pl-10 text-xs"
                />
              </div>
            </div>
            
            {/* CONTACT EMAIL */}
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Store Email Address</label>
              <div className="relative">
                <Mail className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
                <input
                  type="email"
                  value={settings.general.email}
                  onChange={(e) => handleSettingChange('general', 'email', e.target.value)}
                  className="ui-input w-full !pl-10 text-xs"
                />
              </div>
            </div>
            
            {/* PHONE NUMBER */}
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Store Contact Phone</label>
              <div className="relative">
                <Phone className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
                <input
                  type="text"
                  value={settings.general.phone}
                  onChange={(e) => handleSettingChange('general', 'phone', e.target.value)}
                  className="ui-input w-full !pl-10 text-xs"
                />
              </div>
            </div>
          </div>
          
          {/* POSTAL ADDRESS */}
          <div>
            <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Physical Shop Address</label>
            <div className="relative">
              <MapPin className="absolute left-3.5 top-3.5 text-slate-400" size={16} />
              <textarea
                value={settings.general.address}
                onChange={(e) => handleSettingChange('general', 'address', e.target.value)}
                rows="3"
                className="ui-input w-full !pl-10 text-xs resize-none"
              />
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* TAXATION GST */}
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Tax Registration GST Number</label>
              <div className="relative">
                <CreditCard className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
                <input
                  type="text"
                  value={settings.general.gst}
                  onChange={(e) => handleSettingChange('general', 'gst', e.target.value)}
                  className="ui-input w-full !pl-10 text-xs"
                />
              </div>
            </div>
            
            {/* BASE CURRENCY */}
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Default Currency</label>
              <select
                value={settings.general.currency}
                onChange={(e) => handleSettingChange('general', 'currency', e.target.value)}
                className="ui-input w-full text-xs bg-white cursor-pointer"
              >
                <option value="INR">Indian Rupee (₹ INR)</option>
                <option value="USD">United States Dollar ($ USD)</option>
                <option value="EUR">Euro (€ EUR)</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;